<template>
  <!-- 11px of padding over a 48px tab and the 1px line under it make the 60px bar. -->
  <div
    class="
      tw-flex
      tw-items-end
      tw-gap-4
      tw-rounded-tl-2xl
      tw-border-0
      tw-border-b
      tw-border-solid
      tw-border-sf-slate-lighter-1
      tw-bg-sf-slate-subtle-1
      tw-pl-[25px]
      tw-pt-[11px]
      tw-pr-6
      tw-drop-shadow-[0px_1px_0.5px_rgba(0,0,0,0.05)]
    "
  >
    <a
      v-for="tab in tabs"
      :key="tab.key"
      :href="tab.path"
      :class="
        tab.active
          ? 'active tw-font-medium tw-text-sf-slate-dark-2'
          : 'tw-text-sf-slate'
      "
      :aria-current="tab.active ? 'page' : undefined"
      class="
        tw-relative
        tw-flex
        tw-h-12
        tw-items-center
        tw-px-2
        tw-font-sans
        tw-text-base
        tw-leading-[1.4]
        tw-no-underline
      "
    >
      {{ tab.label }}
      <span
        v-if="tab.active"
        class="tw-absolute tw-inset-x-0 tw-bottom-0 tw-h-0.5 tw-bg-sf-primary"
      />
    </a>
  </div>
</template>

<script setup lang="ts">
interface Tab {
  key: string
  label: string
  path: string
  active: boolean
}

interface Props {
  tabs: Tab[]
}

defineProps<Props>()
</script>
